import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(undefined); // `undefined` while checking
  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const snap = await getDoc(doc(db, 'users', firebaseUser.uid));
          if (snap.exists() && snap.data().disabled) {
            await signOut(auth);
            setDisabled(true);
            setUser(null);
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error('Error checking account status:', error);
        }
      }
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <p>Loading...</p>;

  if (disabled) {
    return <Navigate to="/signin" state={{ disabled: true }} />;
  }

  return user ? children : <Navigate to="/signin" />;
};

export default ProtectedRoute;
